import tw from "twin.macro";
import styled from "styled-components";

const TabsControl = tw.div`px-4 pt-4 pb-2`;

const TabControl = styled.button`
  padding: 10px 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  border: none;
  background: none;
  cursor: pointer;
  transition: color .18s;
  width: 50%;
  position: relative;
  color: ${(props) => props.active ? "#6b5330" : "#a6a298"};
  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    height: 3px;
    border-radius: 999px;
    background: linear-gradient(90deg, #6b5330, #9c7a3a);
    width: ${(props) => props.active ? "80%" : "0%"};
    transition: width .22s cubic-bezier(.16,1,.3,1);
  }
  &:hover { color: #6b5330; }
`;

export default (props) => {
  return (
    <TabsControl>
      <div style={{ display: "flex", borderBottom: "2px solid #f0e9fa" }}>
        <TabControl active={props.states ? true : false} onClick={props.details}>
          Payment Details
        </TabControl>
        <TabControl active={props.states ? false : true} onClick={props.onlineTnx}>
          Online Txn Details
        </TabControl>
      </div>
    </TabsControl>
  );
};